import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useMe } from '@/lib/auth'
import { useTRPC } from '@/lib/trpc'
import { primaryWallet, type StrategyView } from '@/lib/api-types'
import { LAMPORTS_PER_SOL } from '@/lib/format'
import { WalletSetup } from '@/components/wallet-setup'
import { StrategiesSection } from '@/components/strategies-section'
import { StrategyDetailModal } from '@/components/strategy-detail-modal'
import { StrategyWizard } from '@/components/strategy-wizard'

export function StrategiesPage() {
  const trpc = useTRPC()
  const { user } = useMe()
  const wallet = primaryWallet(user)
  const ready = Boolean(wallet && user?.walletSetupComplete)
  const [params, setParams] = useSearchParams()
  const [creating, setCreating] = useState(false)
  const [selectedId, setSelectedId] = useState<string | null>(null)
  useEffect(() => {
    const id = params.get('id') ?? params.get('strategy')
    if (id) setSelectedId(id)
    if (params.get('create')) setCreating(true)
    if (id || params.get('create')) setParams({}, { replace: true })
  }, [params, setParams])
  const strategies = useQuery({ ...trpc.strategy.list.queryOptions(), enabled: ready, refetchInterval: 15_000 })
  const portfolio = useQuery({
    ...trpc.portfolio.get.queryOptions({ walletIndex: wallet?.index ?? 0 }),
    enabled: ready,
  })

  if (!ready || !wallet) return <WalletSetup />
  const list = strategies.data ?? []
  const solLamports = portfolio.data?.native?.solana?.balance
  const solBalance = solLamports !== undefined ? Number(solLamports) / LAMPORTS_PER_SOL : undefined

  return (
    <div className="grid gap-6 *:min-w-0">
      {/* the home page's strategies block, with the finished rows open too */}
      <StrategiesSection strategies={list} pending={strategies.isPending} completedOpen onCreate={() => setCreating(true)} onSelect={setSelectedId} />

      <StrategyWizard
        open={creating}
        onClose={() => setCreating(false)}
        wallet={wallet}
        holdings={[...(portfolio.data?.tokens ?? []), ...(portfolio.data?.vault ?? [])]}
        solBalance={solBalance}
      />
      <StrategyDetailModal id={selectedId} onClose={() => setSelectedId(null)} />
    </div>
  )
}
